import React, { useEffect, useState } from "react";
import api from "../../../services/api";

const News = ({ search }) => {
  const [loading, setLoading] = useState(true);
  const [newsItems, setNewsItems] = useState([]);
  const [filtered, setFiltered] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await api.get("/api/news-events");
        setNewsItems(res.data);
        setFiltered(res.data);
      } catch (error) {
        console.error("Failed to load news", error);
      } finally {
        setTimeout(() => setLoading(false), 800);
      }
    };

    fetchNews();
  }, []);

  useEffect(() => {
    const result = newsItems.filter((item) =>
      item.title.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(result);
  }, [search, newsItems]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  return (
    <section className="news-section-list">
      <div className="container">
        <div className="row">

          {loading &&
            [1, 2, 3, 4].map((_, i) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={i}>
                <div className="news-card skeleton">
                  <div className="skeleton-news-img shimmer"></div>
                  <div className="skeleton-line long shimmer mt-3"></div>
                  <div className="skeleton-line medium shimmer"></div>
                </div>
              </div>
            ))
          }

          {!loading && filtered.length === 0 && (
            <p className="no-results">No news found.</p>
          )}

          {!loading &&
            filtered.map((item) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={item.id}>
                <a
                  className="news-card text-decoration-none"
                  href={`/news-details/${item.slug}`}
                >
                  <img src={`${process.env.REACT_APP_WEB_URL}${item.thumbnail}`} alt={item.title} />

                  <div className="news-content">
                    <p>{item.title}</p>
                    <span>
                      <i>{formatDate(item.event_date)}</i>
                    </span>
                  </div>
                </a>
              </div>
            ))
          }

        </div>
      </div>
    </section>
  );
};

export default News;
